import type { FeatureItem } from '../../../mocks/featuresData';

interface FeatureCardProps {
  feature: FeatureItem;
}

export default function FeatureCard({ feature }: FeatureCardProps) {
  return (
    <div
      className="bg-white rounded-[18px] border border-zinc-200 p-6 md:p-7 hover:border-blue-200 transition-all duration-300"
      style={{
        boxShadow: '0 20px 45px -24px rgba(15,23,42,0.35)',
      }}
    >
      <div className="w-10 h-10 flex items-center justify-center bg-blue-600/10 rounded-lg mb-4">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className={`${feature.icon} text-lg text-blue-600`}></i>
        </div>
      </div>
      <span className="inline-block px-3 py-1 bg-zinc-100 text-zinc-600 text-xs font-semibold rounded-full mb-3">
        {feature.tag}
      </span>
      <h3 className="text-base font-bold text-zinc-900 mb-2 leading-snug">
        {feature.headline}
      </h3>
      <p className="text-sm text-zinc-500 leading-relaxed">
        {feature.body}
      </p>
    </div>
  );
}